import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/helpers';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  fullPage?: boolean;
  className?: string;
}

export default function Loading({
  size = 'md',
  text = 'טוען...',
  fullPage = false,
  className,
}: LoadingProps) {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const content = (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Loader2 className={cn('animate-spin text-gold', sizes[size])} />
      {text && <p className="text-sm text-ink-secondary">{text}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-navy-dark/90 z-50">
        {content}
      </div>
    );
  }

  return content;
}
